import { getWidgetBaseUrl } from '../../utils/getBaseURL';
import { Step } from '../../types/steps';
import VideoIframe from './VideoIframe';

// Change this if you need to use a different video
const videoId = 'KVWL6ZyisHqjFXibhXEwbN';

export const Steps: Step[] = [
    {
      number: 1,
      title: "Ask Your Questions",
      description: "Get started with your integrated AI assistant that helps you manage appliances, accounts, alerts, licenses, and more within AppManager. Type in your questions and receive relevant insights.",
      imageUrl: `${getWidgetBaseUrl()}onboarding_step_1.png`
    },
    {
      number: 2,
      title: "Request Visualizations",
      description: "Easily generate charts and tables as visual representations of your data by simply asking for a visualization.",
      imageUrl: `${getWidgetBaseUrl()}onboarding_step_2.png`
    },
    {
      number: 3,
      title: "Customize Your Chat Experience",
      description: "Switch between chat, dock, or fullscreen modes to tailor your interaction with the assistant for maximum productivity.",
      imageUrl: `${getWidgetBaseUrl()}onboarding_step_3.png`
    },
    {
      number: 4,
      title: "Follow Up & Export",
      description: "Ask follow-up questions for deeper insights or clarify previous responses, and export your chat sessions for future reference.",
      imageUrl: `${getWidgetBaseUrl()}onboarding_step_4.png`
    },
    {
      number: 5,
      title: "Walkthrough",
      description: "Watch the following video to get a better understanding of how AppManager AI works.",
      video: (
        <div style={{ 
          position: 'relative', 
          paddingBottom: '51.25%', 
          height: 0,
          // These diminsions prevent the video from having a colored padding at the bottom
          width: '90%',
          maxWidth: '90%',
          margin: '0 auto',
          overflow: 'hidden',
          backgroundColor: 'white'
        }}>
            <VideoIframe
              data-uuid={videoId}
              style={{ 
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }}
            />
        </div>
      )
    }
];